import { cn } from '@/lib/utils';
interface DividerWithPillProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  pillClassName?: string;
}

export function DividerWithPill({
  children,
  className,
  pillClassName,
  ...props
}: DividerWithPillProps) {
  return (
    <div className={cn('flex items-center', className)} {...props}>
      <div className="border-background grow border-t"></div>
      {children && (
        <span className={`text-xxs rounded-full px-5 py-1 font-bold ${pillClassName} `}>
          {children}
        </span>
      )}
      <div className="border-background grow border-t"></div>
    </div>
  );
}
